import { format, parseISO, subMinutes } from "date-fns";
import { id } from "date-fns/locale";
import { ASafetyCheck } from "../../types/safetycheck";

/**
 *
 * @param date the createdAt or updatedAt Date type "string"
 * @param utcOffsetHrs the offset wanted from UTC. defaults to WIB
 * @param formatDate the desire format for the date
 * @returns formatted date as string. Only for show.
 * @deprecated
 */
export const formatDateWithTimezone = (
  date: string,
  utcOffsetHrs = 7,
  formatDate = "yyyy-MM-dd HH:mm:ss"
): string => {
  const dateObject = parseISO(date);
  // Calculate the time zone offset for Asia/Jakarta
  const asiaJakartaOffsetInMinutes = utcOffsetHrs * 60; // Offset for Asia/Jakarta: UTC+07:00 = 7 hours * 60 minutes
  // Adjust the date and time by subtracting the time zone offset
  const adjustedDate = subMinutes(dateObject, asiaJakartaOffsetInMinutes);
  return format(adjustedDate, formatDate, { locale: id });
};

/**
 *
 * @param originalDateString
 * @param formatDate
 * @returns string
 */
export function adjustDateByTime(
  originalDateString: string,
  formatDate: string
): string {
  // Parse the original date string
  const originalDate = new Date(originalDateString);

  // Format the adjusted date as a string
  const formattedAdjustedDate = format(originalDate, formatDate, {
    locale: id,
  });

  return formattedAdjustedDate;
}

export const generateQuestionAnswerSafetyCheckArray = (
  list: ASafetyCheck[]
): {
  title: string;
  list: ASafetyCheck[];
}[] => {
  const temp: {
    [title: string]: ASafetyCheck[];
  } = {};
  const data = list.slice();
  data.forEach((d) => {
    if (!temp[d.category]) {
      temp[d.category] = [];
    }
    const existingObject = temp[d.category].find((item) => item.seq === d.seq);
    if (!existingObject) {
      temp[d.category].push(d);
    }
  });
  let dataMap = Object.keys(temp).map((k) => {
    return {
      title: k,
      list: temp[k],
    };
  });
  return dataMap;
};
